/** Verfolgt aktive Pointer (Maus/Touch/Pen) und erkennt Tap vs. Drag. */
export type PointerPoint = { id: number; x: number; y: number; t: number }

export class PointerSession {
  readonly pointers = new Map<number, PointerPoint>()
  private start = new Map<number, PointerPoint>()
  moved = false
  readonly dragThresholdPx: number

  constructor(dragThresholdPx = 3) {
    this.dragThresholdPx = dragThresholdPx
  }

  down(e: PointerEvent): void {
    const p = { id: e.pointerId, x: e.clientX, y: e.clientY, t: e.timeStamp }
    this.pointers.set(e.pointerId, p)
    this.start.set(e.pointerId, { ...p })
    if (this.pointers.size === 1) this.moved = false
  }

  move(e: PointerEvent): void {
    const p = this.pointers.get(e.pointerId)
    if (!p) return
    p.x = e.clientX
    p.y = e.clientY
    p.t = e.timeStamp
    const s = this.start.get(e.pointerId)
    if (s && !this.moved && Math.hypot(p.x - s.x, p.y - s.y) > this.dragThresholdPx) this.moved = true
  }

  up(e: PointerEvent): void {
    this.pointers.delete(e.pointerId)
    this.start.delete(e.pointerId)
  }

  clear(): void {
    this.pointers.clear()
    this.start.clear()
    this.moved = false
  }

  get count(): number {
    return this.pointers.size
  }

  first(): PointerPoint | null {
    return this.pointers.values().next().value ?? null
  }

  startOf(id: number): PointerPoint | null {
    return this.start.get(id) ?? null
  }
}
